export const UserAPI = {
  details: openapiStrictFetch({ url: 'v2/user' }),
  logout: openapiStrictFetch({
    url: 'v2/auth/logout',
    method: HTTPMethod.POST,
  }),
};
